import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'

export default class OrderPrice extends ApiBase {
  constructor(store) {
    super(store, `${ACTIVE_BASE_REST}/order/price`)
  }

  furniturePrice(model, showProgress) {
    return this._request({
      action: 'furniture',
      method: 'POST',
      body: model,
      showProgress
    })
  }

  cargoPrice(model, showProgress) {
    return this._request({
      action: 'cargo',
      method: 'POST',
      body: model,
      showProgress
    })
  }

  postalPostagePrice(model, showProgress) {
    return this._request({
      action: 'postage',
      method: 'POST',
      body: model,
      showProgress
    })
  }

  deliveryPrice(model, showProgress) {
    return this._request({
      action: 'delivery',
      method: 'POST',
      body: model,
      showProgress
    })
  }

  pickupPrice(model, showProgress) {
    return this._request({
      action: 'pickup',
      method: 'POST',
      body: model,
      showProgress
    })
  }

  materialPrice(model, showProgress) {
    return this._request({
      action: 'material',
      method: 'POST',
      body: model,
      showProgress
    })
  }

  freightPrice(model, showProgress) {
    return this._request({
      action: 'freight',
      method: 'POST',
      body: model,
      showProgress
    })
  }
}
